import { render } from "./LocalUsersAdd.vue?vue&type=template&id=5a4e60e6&scoped=true&ts=true"
import script from "./LocalUsersAdd.vue?vue&type=script&lang=ts"
export * from "./LocalUsersAdd.vue?vue&type=script&lang=ts"

import "./LocalUsersAdd.vue?vue&type=style&index=0&id=5a4e60e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4e60e6"]])

export default __exports__